module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ARE")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("W")]), _vm._v("ithout exception, all of humanity since the dawn of time has arrived here in the womb of a mother that for almost a year carried you with her, no matter whether her load was heavy, and the distance was far")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And the instantaneous connection to a family places you in a hierarchy of siblings, but in your eternal progression, just who do you think you really are?")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("In the world of the natural man there are trains of thought that would have you believe that we are but the apex predator of all life on earth is the tout")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And when you die, that is all there is and the light of life, like a burnt out candle, just goes out.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("There are others that preach seeking Minerva through inner exploration")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In an endless series of ascending reincarnation.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And there are those that have a chosen deity")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("That commands absolute obedience through fear and pain instilled in the words of what will happen if not followed with exact piety.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Even when the words of the prophets are recorded as written, and rewritten, to a single source of understanding that answers the initial question posed")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And the lack of direct communication creates hate and discontent, when the limits of understanding for the natural man now gets answers through a door that is tightly closed.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The true answer is that we are a child of God the Father")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who sent his only begotten son to suffer pure agony and death on the cross at Calvary so the door to heaven’s highest clime was opened wide for those that climbed Jacob’s ladder to the last rung and could go no further.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Without exception, all of humanity since the dawn of time has arrived here in the womb of a mother that for almost a year carried you with her, no matter whether her load was heavy, and the distance was far")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And the instantaneous connection to a family places you in a hierarchy of siblings, but in your eternal progression, just who do you think you really are?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7234f57a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap011.vue
// module id = 99
// module chunks = 0